<template>
    <div id="logout-page">
        <div class="container">
            <div class="row">
                <div class="col-12 pt-5">
                    <p class="text"><i class="fas fa-circle-notch fa-spin mr-3"></i>Loggin out...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Auth from "@/services/AuthService";

export default {
    name: "logout-page",
    components: {
        // 
    },
    mounted() {
        this.logout();
    },
    methods: {
        logout() {
            Auth.logout()
                .then(() => { window.location = "/" })
                .catch(() => { window.location = "/" });
        }
    }
}
</script>
